<template>
  <transition name="fade">
    <div v-if="isPopupVisible" class="main-menu-mobile" :aria-hidden="!isPopupVisible">
      <transition name="slide-up">
        <div class="main-menu-mobile__container">
          <ul class="main-menu-mobile__list">
            <li class="main-menu-mobile__item" v-for="route in routes" :key="route.title" @click="close">
              <MenuItem :route="route.route" :url="route.url" :hash="route.hash">{{ route.title }}</MenuItem>
            </li>
          </ul>
          <div class="main-menu-mobile__controls">
            <VioletFancyButton :route="{ name: 'login' }" class="main-menu-mobile__button">
              Увійти
              <span class="main-menu-mobile__login-icon">
                <LoginIcon />
              </span>
            </VioletFancyButton>
            <OrangeFancyButtonWithArrowAnimation
              :route="{ name: 'promo' }"
              hash="#contacts"
              class="main-menu-mobile__button main-menu-mobile__connect-button"
              @click="close"
            >
              Зв’язатися
            </OrangeFancyButtonWithArrowAnimation>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import MenuItem from './menu-item';
import { OrangeFancyButtonWithArrowAnimation, VioletFancyButton } from '@/shared/ui/form';
import { LoginIcon } from '@/shared/ui/icons';
import { POPUP_EVENTS, popupView } from '@/shared/ui/popup';
import { PROMO_HEADER_MOBILE_EVENTS, PROMO_MOBILE_MENU_EVENTS } from '@/widgets/promo';

export default {
  props: {
    routes: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [ popupView ],
  components: { OrangeFancyButtonWithArrowAnimation, VioletFancyButton, LoginIcon, MenuItem },
  created() {
    this.$eventBus.$on(POPUP_EVENTS.CLOSE, this.handleClosePopup);
    this.$eventBus.$on(PROMO_MOBILE_MENU_EVENTS.PROMO_MOBILE_MENU_OPEN, this.open);
    this.$eventBus.$on(PROMO_MOBILE_MENU_EVENTS.PROMO_MOBILE_MENU_CLOSE, this.close);
  },
  beforeDestroy() {
    this.$eventBus.$off(POPUP_EVENTS.CLOSE, this.handleClosePopup);
    this.$eventBus.$off(PROMO_MOBILE_MENU_EVENTS.PROMO_MOBILE_MENU_OPEN, this.open);
    this.$eventBus.$off(PROMO_MOBILE_MENU_EVENTS.PROMO_MOBILE_MENU_CLOSE, this.close);
  },
  methods: {
    open() {
      this.openPopup();
      //this.$eventBus.$emit(PROMO_MOBILE_MENU_EVENTS.PROMO_MOBILE_MENU_OPEN);
      this.$eventBus.$emit(PROMO_HEADER_MOBILE_EVENTS.PROMO_HEADER_MOBILE_MENU_TOGGLE, true);
    },
    close() {
      this.closePopup(this.getPopupId);
      //this.$eventBus.$emit(PROMO_MOBILE_MENU_EVENTS.PROMO_MOBILE_MENU_CLOSE);
      this.$eventBus.$emit(PROMO_HEADER_MOBILE_EVENTS.PROMO_HEADER_MOBILE_MENU_TOGGLE, false);
    },
    handleClosePopup(data) {
      if (data?.id === this.getPopupId && !data?.isVisible) {
        this.closePopup();
        //this.$eventBus.$emit(PROMO_MOBILE_MENU_EVENTS.PROMO_MOBILE_MENU_CLOSE);
        this.$eventBus.$emit(PROMO_HEADER_MOBILE_EVENTS.PROMO_HEADER_MOBILE_MENU_TOGGLE, false);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main-menu-mobile {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: linear-gradient(to bottom, #CADDFC 0px, #CADDFC 5px, rgba(202, 221, 252, 0.1) 100%);
  padding-right: 12px;
  z-index: 10;
  overflow-y: auto;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding: 16px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  &__list {
    margin-top: 16px;
  }

  &__item {
    margin-bottom: 16px;
  }

  &__controls {
    display: flex;
    justify-content: space-between;
    margin-bottom: 26px;
  }

  &__button {
    width: 100%;

    &.main-menu-mobile__connect-button {
      margin-left: 16px;
    }
  }

  &__login-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #FFFFFF;
    border-radius: 50%;
    margin-left: 10px;
    transform: translateX(0);
    transition: transform .5s;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active, .slide-up-leave-active {
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

.slide-up-enter, .slide-up-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>
